"use client";

import S from "./index.module.scss";
import Header from "@/views/about/components/header";
import { useEffect, useRef, useState } from "react";
import Block from "@/views/about/components/block";

const TRANSITION_DURATION = 240;

const AboutView = () => {
  const [activeChapterID, setActiveChapterID] = useState(0);
  const [previousChapterID, setPreviousChapterID] = useState<number | null>(null);
  const [isChapterChanging, setIsChapterChanging] = useState(false);
  const transitionTimeoutRef = useRef<number | null>(null);
  const chaptersContentRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    return () => {
      if (transitionTimeoutRef.current !== null) {
        window.clearTimeout(transitionTimeoutRef.current);
      }
    };
  }, []);

  const handleChapterChange = (chapterID: number) => {
    const contentElement = chaptersContentRef.current;

    if (contentElement !== null) {
      const contentRect = contentElement.getBoundingClientRect();
      const isContentVisible = contentRect.top < window.innerHeight && contentRect.bottom > 0;

      if (!isContentVisible && contentRect.top >= window.innerHeight) {
        contentElement.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }

    if (chapterID === activeChapterID) {
      return;
    }

    const exitingChapterID = activeChapterID;

    setActiveChapterID(chapterID);
    setPreviousChapterID(exitingChapterID);
    setIsChapterChanging(true);

    if (transitionTimeoutRef.current !== null) {
      window.clearTimeout(transitionTimeoutRef.current);
    }

    transitionTimeoutRef.current = window.setTimeout(() => {
      setPreviousChapterID(null);
      setIsChapterChanging(false);
    }, TRANSITION_DURATION);
  };

  return (
    <main className={S.wrapper}>
      <Header activeChapterID={activeChapterID} onChapterChange={handleChapterChange} />
      <section ref={chaptersContentRef}>
        <Block activeChapterID={activeChapterID} previousChapterID={previousChapterID} isChanging={isChapterChanging} />
      </section>
    </main>
  );
};

export default AboutView;
